{
  "Dashboard": "Tableau de bord",
  "BlyCareShippingProte": "Protection d'expédition BlyCare",
  "LoadingBlyCare": "Chargement de BlyCare…",
  "LoadingWidgetSetting": "Chargement des paramètres du widget…",
  "PreparingYourWorkspa": "Préparation de votre espace de travail",
  "Language": "Langue",
  "English": "English",
  "EnglishDefault": "English (Default)",
  "German": "Deutsch",
  "Spanish": "Español",
  "French": "Français",
  "Italian": "Italiano",
  "Japanese": "日本語",
  "Korean": "한국어",
  "Dutch": "Nederlands",
  "Polish": "Polski",
  "Portuguese": "Português",
  "Ukrainian": "Українська",
  "SimplifiedChinese": "简体中文",
  "TraditionalChinese": "繁體中文",
  "SetupGuide": "Guide de configuration",
  "CompletedOfTotalComp": "{{completed}} sur {{total}} terminés",
  "Dismiss": "Ignorer",
  "MoreActions": "Plus d'actions",
  "ToggleSetupGuide": "Afficher/masquer le guide de configuration",
  "ActivateAppEmbed": "Activer l'intégration d'application",
  "ClickTheEnableButton": "1. Cliquez sur le bouton Activer ci-dessous pour ouvrir l'éditeur de thème Shopify.",
  "BlyCareEmbedSection": "2. Recherchez BlyCare dans la section Intégration d'application à gauche. Assurez-vous que son interrupteur est activé. Cliquez ensuite sur Enregistrer dans le coin supérieur droit.",
  "Enable": "Activer",
  "PublishWidget": "Publier le widget",
  "PublishStorefront": "Publiez le widget sur votre vitrine pour que les clients puissent l'acheter.",
  "Publish": "Publier",
  "SetProtectionFee": "Définir les frais de protection",
  "FeeYouWantToCharge": "Définissez les frais que vous souhaitez facturer aux clients.",
  "Setup": "Configurer",
  "TestYourWidgetOnYour": "Testez votre widget sur votre boutique",
  "AddAProductToYourCar": "Ajoutez un produit à votre panier et vérifiez que le widget de protection d'expédition apparaît. Sélectionnez la protection d'expédition, puis passez à la commande et assurez-vous que le produit de protection d'expédition est inclus sur la page de commande.",
  "TestNow": "Tester maintenant",
  "Working": "Tout fonctionne",
  "NeedHelp": "Besoin d'aide",
  "MarkAsCompleted": "Marquer comme terminé",
  "AppStatus": "État de l'application",
  "AppEmbed": "Intégration d'application",
  "EnableAppEmbedToDisp": "Activez l'intégration d'application pour afficher la protection d'expédition dans le panier.",
  "CartPage": "Afficher la protection d'expédition sur la page du panier.",
  "CheckoutBlock": "Bloc de commande",
  "CheckoutPage": "Afficher la protection d'expédition sur la page de commande.",
  "Active": "Actif",
  "Inactive": "Inactif",
  "Analytics": "Analyses",
  "Today": "Aujourd'hui",
  "Last7Days": "7 derniers jours",
  "Last30Days": "30 derniers jours",
  "Last60Days": "60 derniers jours",
  "Last90Days": "90 derniers jours",
  "Last365Days": "365 derniers jours",
  "Custom": "Personnalisé",
  "Start": "Début",
  "End": "Fin",
  "DateRange": "Période",
  "SelectedRange": "Période sélectionnée : {{range}}",
  "Cancel": "Annuler",
  "Save": "Enregistrer",
  "ChooseAStartDateOnOr": "Choisissez une date de début égale ou antérieure à la date de fin, et ne sélectionnez pas de jour après aujourd'hui.",
  "PreviousMonth": "Mois précédent",
  "NextMonth": "Mois suivant",
  "ProtectionRevenue": "Revenus de protection",
  "ProtectedOrders": "Commandes protégées",
  "ProtectedOrderRate": "Taux de commandes protégées",
  "LoadingAnalytics": "Chargement des analyses…",
  "AnalyticsCouldNotLo": "Impossible de charger les analyses",
  "RetryAnalytics": "Réessayer les analyses",
  "Resources": "Ressources",
  "HowDoesShippingProte": "Comment fonctionne la protection d'expédition ?",
  "BlyCareAddsAShipping": "BlyCare ajoute un widget de protection d'expédition à votre panier. Les clients peuvent choisir d'ajouter une protection à leurs commandes. Le marchand qui perçoit les frais de protection décide des situations couvertes et utilise ces frais pour traiter les réclamations.",
  "DoesBlyCareCoverInsu": "BlyCare couvre-t-il les demandes d'indemnisation d'assurance ?",
  "NoBlyCareIsNotInsura": "Non. BlyCare n'est pas une assurance et ne paie pas les réclamations. BlyCare fournit uniquement le widget et les outils permettant aux marchands de gérer leur propre programme de protection d'expédition.",
  "EmailUs": "Nous envoyer un e-mail",
  "LiveChat": "Chat en direct",
  "HelpCenter": "Centre d'aide",
  "Settings": "Paramètres",
  "CheckoutWidget": "Widget de commande",
  "CartWidget": "Widget du panier",
  "PriceSetting": "Paramètres de prix",
  "ProductSetting": "Paramètres du produit",
  "AdminLanguage": "Langue de l'administration",
  "AdminLanguageTitle": "Langue de l'administration",
  "AdminLanguageHelp": "Modifie la langue de l'application pour vous uniquement. Les clients ne sont pas affectés.",
  "AppLanguage": "Langue de l'application",
  "UnableToLoadSettings": "Impossible de charger les paramètres",
  "TryAgain": "Réessayer",
  "Discard": "Ignorer",
  "LoadingSettings": "Chargement des paramètres",
  "PageNotFound": "Page introuvable",
  "ProductSettingsCould": "Impossible d'enregistrer les paramètres du produit.",
  "Fulfillment": "Expédition",
  "FulfillmentHelp": "Choisissez quand le produit de protection est marqué comme expédié.",
  "ManuallyFulfill": "Expédition manuelle",
  "MarkFulfilledWhenFir": "Marquer comme expédié lorsque le premier article de la commande est expédié",
  "MarkFulfilledWhenAll": "Marquer comme expédié lorsque tous les autres articles de la commande sont expédiés",
  "MarkFulfilledImmedi": "Marquer comme expédié immédiatement après la création de la commande",
  "Exclusions": "Exclusions",
  "ExclusionsHelp": "Choisissez les cas où la protection ne doit pas s'appliquer.",
  "ExclusionType": "Type d'exclusion",
  "Select": "Sélectionner",
  "SelectedExclusions": "Exclusions sélectionnées",
  "RemoveName": "Supprimer {{name}}",
  "WhenExcluded": "En cas d'exclusion",
  "HideWidget": "Masquer le widget",
  "KeepWidgetButSkipThe": "Conserver le widget mais ignorer les frais",
  "ExcludeProductType": "Exclure le type de produit",
  "SearchProductType": "Rechercher un type de produit",
  "ExcludeSKU": "Exclure le SKU",
  "SearchSKU": "Rechercher un SKU",
  "ExcludeCollection": "Exclure la collection",
  "SearchCollection": "Rechercher une collection",
  "ExcludeMarket": "Exclure le marché",
  "SearchMarket": "Rechercher un marché",
  "ExcludeLanguage": "Exclure la langue",
  "SearchLanguage": "Rechercher une langue",
  "Add": "Ajouter",
  "PriceSettingsCouldNo": "Impossible d'enregistrer les paramètres de prix.",
  "ShippingProtectionPr": "Prix de la protection d'expédition",
  "SetHowMuchPriceDoYou": "Définissez le prix à facturer à votre client",
  "PricingMethod": "Méthode de tarification",
  "Fixed": "Fixe",
  "Percentage": "Pourcentage",
  "UniversalProtectionP": "Prix de protection universel",
  "PercentageOfCartSubt": "Pourcentage du sous-total du panier",
  "EditCappedPrice": "Modifier le prix plafonné",
  "ShippingProtectionFe": "Les frais de protection d'expédition sont un pourcentage allant de {{minPrice}} USD, augmentant de {{increment}} USD, plafonné à {{capped}} USD.",
  "MinProtectionFee": "Frais de protection minimum",
  "IncrementAmount": "Montant de l'incrément",
  "CappedProtectionFee": "Frais de protection plafonnés",
  "AddTierPrice": "Ajouter un prix par palier",
  "AddTier": "Ajouter un palier",
  "TierPriceHelp": "Si le prix du panier ne correspond à aucune de vos tranches de prix par palier, le prix universel défini sur la page précédente s'appliquera.",
  "MinCartPrice": "Prix minimum du panier",
  "MaxCartPrice": "Prix maximum du panier",
  "ProtectionFee": "Frais de protection",
  "RemoveTier": "Supprimer le palier",
  "Required": "Obligatoire",
  "ThisFieldIsRequired": "Ce champ est obligatoire.",
  "MustBeGreaterThanZero": "{{label}} doit être supérieur à 0.",
  "MustBeOrLess": "{{label}} doit être inférieur ou égal à {{max}}.",
  "AtMostTwoDecimals": "{{label}} peut avoir au maximum 2 décimales.",
  "MustBeLargerThanMinC": "Doit être supérieur au prix minimum du panier",
  "MustBeLargerThanMaxC": "Doit être supérieur au prix maximum du panier",
  "MustBeSmallerThanMin": "Doit être inférieur au prix minimum du panier",
  "Price": "Prix",
  "MinimumPrice": "Prix minimum",
  "Increment": "Incrément",
  "CartPageWidget": "Widget de la page du panier",
  "CheckoutPageWidget": "Widget de la page de commande",
  "WidgetFormat": "Format du widget",
  "TickerWidget": "Widget standard",
  "CheckoutButtonWidget": "Widget de bouton de commande",
  "Text": "Texte",
  "MainText": "Texte principal",
  "Title": "Titre",
  "Description": "Description",
  "MainButtonText": "Texte du bouton principal",
  "SecondaryButtonText": "Texte du bouton secondaire",
  "EnabledDescription": "Description activée",
  "DisabledDescription": "Description désactivée",
  "PleaseEnterTitle": "Veuillez saisir un titre",
  "PleaseEnterDescript": "Veuillez saisir une description",
  "PleaseEnterMainButt": "Veuillez saisir le texte du bouton principal",
  "PleaseEnterSecondar": "Veuillez saisir le texte du bouton secondaire",
  "PleaseEnterEnabledD": "Veuillez saisir la description activée",
  "PleaseEnterDisabled": "Veuillez saisir la description désactivée",
  "EGViewTerms": "ex. Voir les conditions",
  "EGHttpTerms": "ex. https://terms.com",
  "Footer": "Pied de page",
  "FooterText": "Texte du pied de page",
  "FooterLink": "Lien du pied de page",
  "TooltipLink": "Lien de l'infobulle",
  "FooterVisibility": "Visibilité du pied de page",
  "TitleInfoVisibility": "Visibilité des informations du titre",
  "Disabled": "Désactivé",
  "Enabled": "Activé",
  "Color": "Couleur",
  "ColorStyle": "Style de couleur",
  "SizeAndDisplay": "Taille et affichage",
  "IconSize": "Taille de l'icône",
  "IconRadius": "Rayon de l'icône",
  "BorderSize": "Taille de la bordure",
  "BorderRadius": "Rayon de la bordure",
  "HorizontalPadding": "Marge intérieure horizontale",
  "VerticalPadding": "Marge intérieure verticale",
  "ToggleFormat": "Format de l'interrupteur",
  "Switch": "Interrupteur",
  "Checkbox": "Case à cocher",
  "Border": "Bordure",
  "Background": "Arrière-plan",
  "ProtectionDescript": "Description de la protection",
  "MainButtonBackgrou": "Arrière-plan du bouton principal",
  "EnabledToggle": "Interrupteur activé",
  "DisabledToggle": "Interrupteur désactivé",
  "Automatic": "Automatique",
  "Neutral": "Neutre",
  "Info": "Info",
  "Success": "Succès",
  "Warning": "Avertissement",
  "Critical": "Critique",
  "Subdued": "Atténué",
  "Transparent": "Transparent",
  "ThemeColor": "Couleur du thème",
  "ResetToDefaultColor": "{{label}} : rétablir la couleur par défaut",
  "OpenColorPicker": "{{label}} : ouvrir le sélecteur de couleur",
  "Icon": "Icône",
  "PackageIcon": "Icône de colis",
  "PackageIconNumber": "Icône de colis {{value}}",
  "UploadIcon": "Téléverser une icône",
  "NoIcon": "Aucune icône",
  "AcceptedFormats": "Formats acceptés : PNG, JPG, SVG",
  "MaximumFileSize": "Taille de fichier maximale : 50 MB",
  "AddFiles": "Ajouter des fichiers",
  "RemoveImage": "Supprimer l'image",
  "Uploading": "Téléversement en cours",
  "UploadFailedTryAgain": "Échec du téléversement. Réessayez.",
  "ChooseAJPEGPNG": "Choisissez une image JPEG, PNG ou SVG de 50 MB maximum.",
  "ChooseNonemptyImage": "Choisissez une image JPEG, JPG, PNG ou SVG non vide de 50 MB maximum.",
  "ImageCouldNotBeRead": "L'image n'a pas pu être lue.",
  "FileContentsMismatch": "Le contenu du fichier doit correspondre à son type d'image JPEG, PNG ou SVG.",
  "ImageCouldNotBeDecode": "L'image n'a pas pu être décodée.",
  "InvalidImageUrl": "Le service de téléversement a renvoyé une URL d'image non valide.",
  "MissingPublicImageUrl": "Le service de téléversement n'a pas renvoyé d'URL d'image publique.",
  "CustomCssTooLong": "Le CSS personnalisé doit comporter au maximum 2 000 caractères.",
  "ChooseValidIconUrl": "Choisissez une icône téléversée avec une URL valide.",
  "EnterNumberRange": "Saisissez un nombre de {{min}} à {{max}}.",
  "EnterLocaleTextRange": "Saisissez un texte {{locale}} entre 1 et {{limit}} caractères.",
  "EnterValidLearnMoreUrl": "Saisissez une URL En savoir plus valide commençant par https:// ou http://.",
  "ReviewHighlightedFields": "Vérifiez les champs en surbrillance.",
  "CannotChangePublishState": "Impossible de modifier l'état de publication tant que le formulaire n'est pas valide : {{reason}}",
  "BlyCareCouldNotSave": "BlyCare n'a pas pu enregistrer.",
  "CheckoutRequiresPlus": "La personnalisation de la commande nécessite Shopify Plus.",
  "SaveSucceededReloadFailed": "La demande d'enregistrement a réussi, mais les derniers paramètres du widget n'ont pas pu être chargés. Actualisez pour vérifier vos modifications.",
  "BlyCareCouldNotComplete": "BlyCare n'a pas pu terminer cette demande.",
  "ShopifyAuthorizationRequired": "L'autorisation Shopify est requise.",
  "AppBridgeUnavailable": "Shopify App Bridge n'est pas disponible",
  "ExtensionStatusUnavailable": "Le statut de l'extension Shopify est indisponible.",
  "ConfigurationPreview": "Aperçu de la configuration",
  "On": "Activé",
  "Off": "Désactivé",
  "Unpublish": "Dépublier",
  "AppEmbedIsNotEnable": "L'intégration d'application n'est pas activée.",
  "GoEnabled": "Accéder à l'activation",
  "ViewOnYourStorefront": "Voir sur votre vitrine",
  "PreviewProtection": "Aperçu de la protection",
  "MoreInformation": "Plus d'informations",
  "Cart": "Panier",
  "Subtotal": "Sous-total",
  "Checkout": "Commande",
  "DiscountCode": "Code de réduction",
  "Apply": "Appliquer",
  "Shipping": "Expédition",
  "Total": "Total",
  "ShippingProtection": "Protection d'expédition",
  "Product": "Produit",
  "CopyLink": "Copier le lien"
}
